const CategoryNavLinkBuilderComponent = {
  name: '_CategoryNavLink_',
  canHaveChildren: true,
  childRequirements: {
    message: 'Child component for a CategoryNavLink must be a CategoryNavLink.',
    query: {
      'component.name': {
        $in: ['_CategoryNavLink_'],
      },
    },
  },
  inputs: [
    {
      name: 'linkText',
      friendlyName: 'Category Nav Link Text',
      helperText: 'The category text displayed as the link.',
      type: 'string',
      defaultValue: 'Womens',
      localized: true,
      required: true,
    },
    {
      name: 'linkPath',
      friendlyName: 'Category Nav Link Path',
      helperText: 'Only include the URL path. Ex- /womens',
      type: 'string',
      defaultValue: '/womens',
      localized: true,
      required: true,
    },
  ],
} as const;

export default CategoryNavLinkBuilderComponent;
